import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from './_services/authentification.service';
import { SessionTimeoutService } from './_services/session-timeout.service.spec';
import { User, Role } from './_models/oauth.models';

@Component({ selector: 'app-root', templateUrl: 'app.component.html' })
export class AppComponent {
   
  currentUser: User;

  constructor( private router: Router,
       private authenticationService: AuthenticationService, private sessionTimeoutService: SessionTimeoutService) {
     
        this.authenticationService.currentUser.subscribe(          
          x =>{ this.currentUser = x; console.log('Observer got a next value: ' + x) },
          err => console.log('Observer got an error: ' + err),
          () => console.log('Observer got a complete notification')

        );
  }

}
